// @ts-nocheck
import userProfile from "./userProfile";
import eventsApi from "./events";
import categoriesApi from "./Categories/categories";
import requestMixin from "../Common/requestMixin";
import fightsApi from "./fights";
import eventCompetitorsApi from "./eventCompetitors";
import academiesApi from "./academies";
import sharingApi from "./sharing";
import eventSettingsApi from "./eventSettingsApi";
import schedulesApi from "./schedules";
import mats from "./mats";
import bracketsApi from "./brackets";
import competitorResults from "./competitorResultsApi";
import recordProfile from "./recordProfile";
import notificationsCenter from "./notificationsCenter";
import billing from "./billing";
import registration from "./registration";
import liveStreams from "./liveStreams";
import registeredCompetitorsManagement from "./registeredCompetitorsManagement";

export default {
    mixins: [requestMixin],
    methods: {
        registeredCompetitorsManagementApi() {
            return registeredCompetitorsManagement.init(this.promiseRequest);
        },
        liveStreamsApi() {
            return liveStreams.init(this.promiseRequest);
        },
        registrationApi() {
            return registration;
        },
        billingApi() {
            return billing.init(this.promiseRequest);
        },
        notificationsCenterApi() {
            return notificationsCenter.init(this.promiseRequest);
        },
        recordProfileApi() {
            return recordProfile.init(this.promiseRequest);
        },
        competitorResultsApi() {
            return competitorResults;
        },
        eventsApi() {
            return eventsApi;
        },
        eventSettingsApi() {
            return eventSettingsApi;
        },
        categoriesApi() {
            return categoriesApi;
        },
        fightsApi() {
            return fightsApi;
        },
        eventCompetitorsApi() {
            return eventCompetitorsApi;
        },
        academiesApi() {
            return academiesApi;
        },
        sharingApi() {
            return sharingApi.init(this.promiseRequest);
        },
        schedulesApi() {
            return schedulesApi;
        },
        matsApi() {
            return mats;
        },
        bracketsApi() {
            return bracketsApi;
        },
        userProfileApi() {
            return userProfile;
        },
    },
};
